import styled from 'styled-components';
var NavStepper = styled.ol.withConfig({
  displayName: "NavStepper",
  componentId: "sc-1gs7z7r-0"
})(["padding-bottom:0;text-align:center;"]);
export default NavStepper;